import { HttpConfiguration } from '../../app.http.config';
import { RequestTypes } from '../../models/enums/request-types.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import DictionaryStr from './../../models/dictionary';

@Injectable()
export class HttpService {
    protected server = '';
    protected actionUrl = '';
    protected headers: HttpHeaders;
    protected options: any;

    jsonType = 'application/json';

    constructor(apiUrl: string, requestType: RequestTypes, private readonly httpConfig: HttpConfiguration, private readonly http: HttpClient) {

        // Http config
        this.server = httpConfig.servers[requestType];

        // Action
        this.actionUrl += apiUrl;
        if (this.actionUrl.length > 0 && this.actionUrl[this.actionUrl.length - 1] !== '/') {
            this.actionUrl += '/';
        }

        // Headers
        const headersObject: any = {
            'Content-Type': this.jsonType,
            'Accept': this.jsonType,
            'C-Timeshift': new Date().getTimezoneOffset() * -1,

        };

        try {
            if (Intl && Intl.DateTimeFormat() && Intl.DateTimeFormat().resolvedOptions() && Intl.DateTimeFormat().resolvedOptions().timeZone) {
                headersObject['C-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        } catch (e) {
            console.log(`Intl error: ${e}`);
        }

        this.headers = new HttpHeaders(headersObject);
    }

    protected get(methodName: string, queryParams: DictionaryStr<string>): Observable<any> {
        let params: any;

        if (queryParams) {
            params = this.createHttpParams(queryParams);
        } else {
            params = queryParams;
        }

        const options = {
            headers: this.headers,
            params: params,
        };

        return this.http.get(this.server + this.actionUrl + methodName, options);
    }

    protected postUrlEncoded(methodName: string, object: any): Observable<any> {
        const options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };

        return this.http.post(this.server + this.actionUrl + methodName, object, options);
    }

    protected post(methodName: string, object: any): Observable<any> {
        const options = {
            headers: this.headers,
        };

        return this.http.post(this.server + this.actionUrl + methodName, object, options);
    }

    protected postReCaptcha(methodName: string, object: any, token: string): Observable<any> {
        const headersObject: any = {
            'Content-Type': this.jsonType,
            'Accept': this.jsonType,
            'g-recaptcha-response': token
        };

        const headers = new HttpHeaders(headersObject);

        const options = {
            headers: headers,
        };

        return this.http.post(this.server + this.actionUrl + methodName, object, options);
    }

    protected getUrl(url: string): Observable<any> {
        const options = {
            headers: this.headers,
        };

        return this.http.get(url, options);
    }

    //
    // ASYNC PROMISES
    //
    protected async postAsync<T>(methodName: string, object: any): Promise<any> {
        const options = {
            headers: this.headers,
            withCredentials: false
        };

        return await this.http.post(this.server + this.actionUrl + methodName, object, options)
            .pipe()
            .toPromise();
    }

    protected async getAsync<T>(methodName: string, queryParams: DictionaryStr<string>): Promise<any> {
        const options = {
            params: queryParams
        };

        return await this.http.get(this.server + this.actionUrl + methodName, options)
            .pipe()
            .toPromise();
    }

    protected async getJsonAsync<T>(methodName: string, queryParams: DictionaryStr<string>): Promise<any> {
        const options = {
            params: queryParams
        };

        return await this.http.get(this.server + this.actionUrl + methodName, options)
            .pipe().toPromise();
    }

    public postMultipart(methodName: string, object: any): Observable<any> {

        const headersObject: any = {
            'Accept': this.jsonType,
        };

        this.headers = new HttpHeaders(headersObject);

        const options = {
            headers: this.headers,
        };

        return this.http.post(this.actionUrl + methodName, object, options);
    }

    createHttpParams(params: any): HttpParams {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach((param: any) => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });

        return httpParams;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/http/http.service.ts